import { connect } from '@atlassian/jira-react-redux';
import {
	MAX_AUTOMATION_RULES_PER_SD,
	withLimitData,
} from '@atlassian/jira-servicedesk-common/src/ui/components/limit-data';
import { maybeRuleSetIds } from '../../../../state/selectors/rulesets';
import type { State } from '../../../../state/types';
import AddButton, { type Props } from './view';

const ruleLimitReached = (state: State, limit: number): boolean =>
	maybeRuleSetIds(state)
		// @ts-expect-error - TS7006 - Parameter 'rules' implicitly has an 'any' type.
		.map((rules) => rules.length >= limit)
		.orSome(false);

const mapStateToProps = (state: State, ownProps: Props) => ({
	ruleLimitReached: ruleLimitReached(state, ownProps.limit),
});

const AddButtonContainer = connect(mapStateToProps, {})(AddButton);

export default withLimitData(MAX_AUTOMATION_RULES_PER_SD, AddButtonContainer);
